import { takeEvery, put } from "redux-saga/effects";
import { request } from "../../../api/Service";
import { getErrorMessage } from "../../../components/utils/errorHandler";
import { toast } from "react-toastify";

export default function* watcherGetOnlinePaymentSaga() {
  yield takeEvery("LOAD_ONLINE_PAYMENT", workerSaga);
}

function* workerSaga(action) {
  try {
      console.log(action)
    var payload = {};
    yield put({ type: "DISPLAY_LOADER", payload: payload });
   var formatUrl = `api/SalesTransactionV2/online?companyId=${action.payload.companyId}`;
    yield request("get", {}, formatUrl).then((response) => {
      payload = response;
    });
    yield put({ type: "ONLINE_PAYMENT_LIST", payload: payload });
    yield put({ type: "DISPLAY_LOADER", payload: payload });
  } catch (e) {
    console.log(e);
    console.log("product-saga", e);
    console.log("product-saga", e.response);
    yield put({ type: "LOADING_BUTTON_SPINNER" });
    const errorMessage = getErrorMessage(e.response);
    toast.error(errorMessage);
    yield put({ type: "API_ERRORED", payload: e });
    yield put({ type: "DISPLAY_LOADER", payload: payload });
  }
}
